import React from "react";
import Youtube from "../Youtube/Youtube";
import { Box, Container } from "@mui/material";
import { youTubeUrl } from "../../assets/function";
import { Colors } from "../../assets/colors";

function Youtubevideo() {
  return (
    <Box sx={styles.appBarStyle}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <Youtube
          url={youTubeUrl}
          divStyle={styles.youtube}
          width="100%"
          height="100%"
          playerStyle={styles.playerStyle}
          autoplay
        />
      </Container>
    </Box>
  );
}

export default Youtubevideo;

const styles = {
  appBarStyle: {
    backgroundColor: Colors.themeColor,
  },
  containerStyle: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    backgroundColor: Colors.themeColor,
    padding: { xs: "40px 10px", sm: "30px 20px" },
  },
  youtube: {
    width: { xs: "92%", sm: "80%", md: "65%", lg: "48%" },
    height: "auto",
    minWidth: { xs: "280px", sm: "400px" },
    maxWidth: "1100px",
    aspectRatio: "16 / 9",
    margin: "0 auto",
  },
  playerStyle: {
    border: "none",
    display: "block",
    margin: "0 auto",
    width: "100%",
    height: "100%",
  },
};
